import { PRODUCT_TYPES } from 'constants/dictionaries';

export const getProductTypesByQuery = (productTypes?: string | string[]) => {
  if (Array.isArray(productTypes)) {
    const validProductType = PRODUCT_TYPES.filter((productType) => productTypes.includes(productType.value)).map(
      (productType) => productType.value,
    );

    return validProductType?.length === 0 ? undefined : validProductType;
  }

  if (productTypes) {
    const productType = PRODUCT_TYPES?.find((item) => item?.value === productTypes);

    return productType ? [productType?.value] : undefined;
  }
};
